import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { FABRIC_PRODUCT_OPTION_ID, PDP_DECIDELATER_TAB_ID } from 'commons/constants';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import usePDPOptions from 'components/consumer/PDP/state/context/usePDPOptions';
import usePDPClearanceData from 'data-hooks/useClearanceData/usePDPClearanceData';
import useUserData from '../useUserData';
import { getOptionAdditionalPrice } from '../useProductPrice/utils';
const DEFAULT_OPTIONS = [];
const DEFAULT_SELECTED_OPTIONS = {};
const DEFAULT_PRICE_OBJ = {};
const usePDPPrice = (id, slug, t0) => {
  const $ = _c(38);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hookOptions = t1;
  const {
    isTradeUser,
    userDiscount
  } = useUserData();
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const isDecideLaterTab = pdpSelectedCustomizerTab === PDP_DECIDELATER_TAB_ID;
  const {
    loading: basicLoading,
    data: basicData
  } = usePDPBasicDetails() ?? {};
  const {
    loading: optionsLoading,
    data: optionsData
  } = usePDPOptions() ?? {};
  const clearanceHookData = usePDPClearanceData(hookOptions);
  let t2;
  if ($[2] !== clearanceHookData?.data) {
    t2 = clearanceHookData?.data || {};
    $[2] = clearanceHookData?.data;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    isClearance: t3,
    stockCost: t4,
    clearanceStockPerSKU,
    productCardVariantSKU,
    clearanceProductSku
  } = t2;
  const isClearance = t3 === undefined ? false : t3;
  const stockCost = t4 === undefined ? 0 : t4;
  let t5;
  if ($[4] !== optionsData) {
    t5 = optionsData || {};
    $[4] = optionsData;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const {
    options: t6,
    selectedOptions: t7,
    stock
  } = t5;
  const options = t6 === undefined ? DEFAULT_OPTIONS : t6;
  const selectedOptions = t7 === undefined ? DEFAULT_SELECTED_OPTIONS : t7;
  let t8;
  bb0: {
    const selectedFabricOptionValueId = selectedOptions?.[FABRIC_PRODUCT_OPTION_ID];
    if (selectedFabricOptionValueId) {
      const fabricOption = options?.length ? options.find(_temp) : null;
      if (fabricOption?.values?.length > 0) {
        const fabricOptionValue = fabricOption.values.find(o_0 => o_0.id === selectedFabricOptionValueId);
        t8 = fabricOptionValue?.exclude_from_sale ?? false;
        break bb0;
      }
    }
    t8 = false;
  }
  const isFabricExcludedFromSale = t8;
  let t9;
  bb1: {
    if (!basicData?.meta?.price) {
      t9 = DEFAULT_PRICE_OBJ;
      break bb1;
    }
    const originalPrice = basicData?.meta?.price?.original_price || 0;
    if (isClearance && !isDecideLaterTab) {
      const t10 = originalPrice + stockCost;
      let t11;
      if ($[6] !== basicData.meta.price || $[7] !== t10) {
        t11 = {
          ...basicData.meta.price,
          final_price: t10
        };
        $[6] = basicData.meta.price;
        $[7] = t10;
        $[8] = t11;
      } else {
        t11 = $[8];
      }
      t9 = t11;
      break bb1;
    }
    if (isFabricExcludedFromSale && !isDecideLaterTab) {
      const t10 = isTradeUser ? userDiscount : 0;
      const t11 = isTradeUser ? userDiscount : 0;
      let t12;
      if ($[9] !== isTradeUser || $[10] !== originalPrice || $[11] !== userDiscount) {
        t12 = isTradeUser ? Math.round(originalPrice * (100 - userDiscount) / 100) : originalPrice;
        $[9] = isTradeUser;
        $[10] = originalPrice;
        $[11] = userDiscount;
        $[12] = t12;
      } else {
        t12 = $[12];
      }
      let t13;
      if ($[13] !== basicData.meta.price || $[14] !== t10 || $[15] !== t11 || $[16] !== t12) {
        t13 = {
          ...basicData.meta.price,
          discount_percent: t10,
          max_discount_percent: t11,
          final_price: t12
        };
        $[13] = basicData.meta.price;
        $[14] = t10;
        $[15] = t11;
        $[16] = t12;
        $[17] = t13;
      } else {
        t13 = $[17];
      }
      t9 = t13;
      break bb1;
    }
    t9 = basicData.meta.price;
  }
  const priceObj = t9;
  let t10;
  if ($[18] !== isDecideLaterTab || $[19] !== options || $[20] !== optionsData?.upholsteryOptionId || $[21] !== selectedOptions || $[22] !== stock?.stockOptions) {
    t10 = () => getOptionAdditionalPrice(options, stock?.stockOptions, selectedOptions, !isDecideLaterTab, optionsData?.upholsteryOptionId);
    $[18] = isDecideLaterTab;
    $[19] = options;
    $[20] = optionsData?.upholsteryOptionId;
    $[21] = selectedOptions;
    $[22] = stock?.stockOptions;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  stock?.stockOptions;
  optionsData?.upholsteryOptionId;
  let t11;
  if ($[24] !== t10) {
    t11 = t10();
    $[24] = t10;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const optionPrice = t11;
  let t12;
  if ($[26] !== basicData || $[27] !== clearanceProductSku || $[28] !== clearanceStockPerSKU || $[29] !== isClearance || $[30] !== optionPrice || $[31] !== priceObj || $[32] !== productCardVariantSKU || $[33] !== stockCost) {
    t12 = basicData ? {
      price: priceObj,
      promotion: basicData?.meta?.promotion,
      optionPrice,
      isClearance,
      stockCost,
      clearanceStockPerSKU,
      productCardVariantSKU,
      clearanceProductSku
    } : null;
    $[26] = basicData;
    $[27] = clearanceProductSku;
    $[28] = clearanceStockPerSKU;
    $[29] = isClearance;
    $[30] = optionPrice;
    $[31] = priceObj;
    $[32] = productCardVariantSKU;
    $[33] = stockCost;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  const pdpPriceData = t12;
  const t13 = optionsLoading || basicLoading;
  let t14;
  if ($[35] !== pdpPriceData || $[36] !== t13) {
    t14 = {
      loading: t13,
      data: pdpPriceData
    };
    $[35] = pdpPriceData;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  return t14;
};
export default usePDPPrice;
function _temp(o) {
  return o.id === FABRIC_PRODUCT_OPTION_ID;
}